<!--
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2023-09-12 16:32:54
 * @LastEditors: fangzhi fangzhi@vivo.com
 * @LastEditTime: 2023-09-12 17:33:50
 * @FilePath: /h5/src/components/header-menu/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="header-menu" v-show="isShowMenu">
    <div class="overlay" @click.stop="close"></div>
    <div :class="['mod-nav', isShowMenu ? 'show' : '']" v-statusBarHeight="'margin-top'">
      <div class="item home" @click="toHome">首页</div>
      <div class="item buy" @click="toNav">选购商品</div>
      <div class="item center" @click="toMy">个人中心</div>
      <div class="item concat" @click="toConnect">在线客服</div>
    </div>
  </div>
</template>

<script>
import create from '../create'
import { jumpToHome, jumpToNav, jumpToMy, jumpToKeFu } from 'utils/common'
export default create({
  name: 'headerMenu',
  props: {
    isShowMenu: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // 防止滚动穿透
    isShowMenu(val) {
      document.body.style.overflow = val ? 'hidden' : 'auto'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    toHome() {
      jumpToHome()
    },
    toNav() {
      jumpToNav()
    },
    toMy() {
      jumpToMy()
    },
    toConnect() {
      jumpToKeFu()
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
